export default "__VITE_ASSET__Cd0Dy238__"